export default {
    'journal-number-automatic-or-manual': 'Journal ID (auto or manual)',
    warehouse: 'Warehouse',
    add: 'Add',
    delete: 'Delete',
    save: 'Save',
    edit: 'Edit',
    'view-invoice': 'View invoice',
    'view-manufacturing-bond': 'View manufacturing bond',
    not: 'Non',
    posted: 'Posted',
    'add-journal': 'New journal',
    'journal-date': 'Journal date',
    create: 'Create',
    cancel: 'Cancel',

    'delete-entry': 'Delete this item ',
    'are-you-sure-you-want-to-delete-the-entry': 'Do you want to delete this item?',

    'delete-journal': 'Delete journal',
    'are-you-sure-you-want-to-delete-the-journal': 'Do you want to delete this journal?',
    
    'make-sure-the-data-entered-is-correct': 'Verify sure the data entered is correct',

    headers: {
        'no': 'Serial',
        'in-quantity': 'Incoming quantity',
        'out-quantity': 'Outcoming quantity',
        'warehouse': 'Warehouse',
        'material': 'Item',
        'count': 'Count',
        'price': 'Price',
        'notes': 'Notes',
        'document': 'Ref. Doc.',
        'account': 'Account',
        'date': 'Date',
    },

    'context-menu': {
        'material-statement': 'Item statement',
        'edit': 'Edit',
        'delete-item': 'Delete',
    }
}